import LogoImage from './LogoImage'

export default LogoImage
